import React, { Component } from "react";
import PresentationMenu from "../components/header/PresentationMenu";

export default class PresentationMenuContainer extends Component {
  state = {
    anchorEl: null,
    slideshows: [],
    slideshowsLoaded: false
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("slideshows")
      .onSnapshot(querySnapshot => {
        var slideshows = [];
        querySnapshot.forEach(function(doc) {
          let slideshow = doc.data();
          slideshow.id = doc.id;
          slideshows.push(slideshow);
        });
        this.setState({
          slideshows: slideshows,
          slideshowsLoaded: true
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  generateProps = () => ({
    ...this.state,
    ...this.props,
    open: Boolean(this.state.anchorEl),
    handleMenu: this.handleMenu,
    handleClose: this.handleClose
  });

  render() {
    return <PresentationMenu {...this.generateProps()} />;
  }
}
